/// <amd-module name="typeahead/features/HierarchyRegionTypeIconEnabler" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [{
    experiment: {
        id: 25399,
        name: "ESS_Region_Type_Specific_Icon_for_Hierarchy",
        value: 1,
    },
    lobs: ["HOTELS"],
}];

export class HierarchyRegionTypeIconEnabler implements ISuggestionsModifier, IExperimentalFeature {
    public modifySuggestions(suggestions: any, context: IContext, options: any): Object[] {
        if (suggestions && suggestions.length > 0) {
            let useReturnIcon: boolean = undefined;
            suggestions.forEach((sugg): void => {
                if (TypeaheadUtils.isChildSuggestion(sugg, options.renderTrigger)) {
                    if (useReturnIcon === undefined) {
                        useReturnIcon = !ExecutionHelper.shouldExecute(context, configuration);
                    }
                    if (useReturnIcon) {
                        sugg.icon = "return";
                    }
                }
            });
        }
        return suggestions;
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
